import React from 'react';
import { Outlet } from 'react-router-dom';

const TechnologiesPage = () => {
  return <Outlet />;
};

export default TechnologiesPage;
